module.exports = __webpack_public_path__ + "assets/img/travel-day39.1cd410d2.png";